import React, { useState } from 'react'

import spacetime from 'spacetime'

import { InlineSelect } from '@driftt/dds'

import useOrgId from 'hooks/useOrgId'
import useUserId from 'hooks/useUserId'
import { trackMeetingOutcomesChanged } from 'utils/tracking'

interface MeetingOutcomeCellProps {
  status: string
  eventId: string
  meetingEnd: number
  updateStatus: (eventId: string, newValue: string) => void
}

const STATUS_HUMANIZED_TRANSLATION = {
  ACTIVE: 'Scheduled',
  CANCELED: 'Canceled',
  RESCHEDULED: 'Rescheduled',
  NO_SHOW: 'No-show',
  HELD: 'Held',
  UKNOWN: 'Select an outcome',
}

const OutcomeSelectOptions = Object.entries(STATUS_HUMANIZED_TRANSLATION).map(
  ([key, value]: [string, string]) => {
    return { value: key, label: value }
  }
)

export default function MeetingOutcomeCell({
  status,
  eventId,
  meetingEnd,
  updateStatus,
}: MeetingOutcomeCellProps) {
  const [meetingStatus, setMeetingStatus] = useState(status)
  const isMeetingInPast = spacetime(meetingEnd).isBefore(spacetime.now())
  //tracking data
  const userId = useUserId()
  const orgId = useOrgId()

  const onOutcomeChange = (newValue: string) => {
    setMeetingStatus(newValue)
    updateStatus(eventId, newValue)
    trackMeetingOutcomesChanged({
      userId,
      orgId,
      eventId,
      oldStatus: status,
      newStatus: newValue,
    })
  }

  return isMeetingInPast ? (
    <InlineSelect
      options={OutcomeSelectOptions}
      label={''}
      value={meetingStatus}
      onValueChange={onOutcomeChange}
      placeholder="Select an outcome"
    />
  ) : (
    <>
      {
        STATUS_HUMANIZED_TRANSLATION[
          meetingStatus as keyof typeof STATUS_HUMANIZED_TRANSLATION
        ]
      }
    </>
  )
}
